import { createContext, useContext } from 'react';
import type { ScopeGroup } from './groupSections';

// =============================================================================
// ScopeSectionsContext — 콘텐츠를 그룹 묶음으로 그릴 때 필요한 두 값.
// 플레이리스트 화면이 한 번 넣어 주면 깊숙한 자식(템플릿 갤러리 등)이 props 없이 꺼내 쓴다(2026-09-15).
// 기본값(그룹 없음·중앙 아님)이면 옛 평면 목록 그대로.
//
// 2026-09-16 대교 결정으로 `grouped`(그룹이 있는 조직인가) 대신 `central`(중앙 권한자인가)을 든다.
// 묶음 여부는 이제 groups.length + central이 스스로 정하고, 중앙 소유 자료('내 자료')를
// 볼 수 있는 사람인지가 화면을 가르는 기준이기 때문.
// =============================================================================

export type ScopeSections = { groups: ScopeGroup[]; central: boolean };

export const ScopeSectionsContext = createContext<ScopeSections>({ groups: [], central: false });

export function useScopeSections(): ScopeSections {
  return useContext(ScopeSectionsContext);
}
